import { render, staticRenderFns } from "./PartnerRepAprModelMobile.vue?vue&type=template&id=387cdd59&scoped=true"
import script from "./PartnerRepAprModelMobile.vue?vue&type=script&lang=ts"
export * from "./PartnerRepAprModelMobile.vue?vue&type=script&lang=ts"
import style0 from "./PartnerRepAprModelMobile.vue?vue&type=style&index=0&id=387cdd59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cdd59",
  null
  
)

export default component.exports